import * as _ from 'lodash';

export default ['$scope', '$mdDialog', 'product', function (scope, dialogService, product) {

    const shortDescriptionLimit = 160;

    _.assign(scope, product);

    scope.showFullDescription = false;
    scope.showMoreLess = (product.description.length > shortDescriptionLimit);
    scope.descriptionTruncated = product.description.substring(0, shortDescriptionLimit);

    scope.ok = () => dialogService.hide();
}];


// WEBPACK FOOTER //
// ./src/modules/catalog/controllers/ProductDetailController.js